import { defineComponent as r } from "vue";
import { D as s } from "./DIcon-DfNlyxiw.js";
import { a as i, b as f, E as a } from "./const-DEOau_fL.js";
import "./_baseClone-CPYgn-G_.js";
import { n } from "./index.browser-CWCjzKuA.js";
import { n as t } from "./_plugin-vue2_normalizer-WQT2Fc8L.js";
import './assets/DFormField-IwOq86X4.css';var _ = /* @__PURE__ */ ((o) => (o.LARGE = "large", o.SMALL = "small", o))(_ || {});
const c = r({
  components: {
    DIcon: s
  },
  props: {
    clearable: Boolean,
    blocked: Boolean,
    disabled: Boolean,
    dark: Boolean,
    error: Boolean,
    size: { type: String, default: () => _.LARGE },
    loading: Boolean,
    focused: Boolean,
    hasValue: Boolean,
    hideLabelOnFocus: Boolean,
    id: { type: String, default: () => n() }
  },
  emits: ["clear", "click"],
  setup(o, { emit: e }) {
    return {
      EIconColor: i,
      ESize: _,
      EIcon: f,
      EIconSize: a,
      onClear: () => {
        e("clear");
      }
    };
  }
}), m = "_spin_sb5u1_1", b = {
  "d-form-field": "_d-form-field_sb5u1_7",
  "d-form-field_state-focused": "_d-form-field_state-focused_sb5u1_55",
  "d-form-field_state-error": "_d-form-field_state-error_sb5u1_58",
  "d-form-field_state-disabled": "_d-form-field_state-disabled_sb5u1_58",
  "d-form-field_color-dark": "_d-form-field_color-dark_sb5u1_68",
  "d-form-field_size-small": "_d-form-field_size-small_sb5u1_80",
  "d-form-field_size-small_with-label": "_d-form-field_size-small_with-label_sb5u1_80",
  "d-form-field__control": "_d-form-field__control_sb5u1_91",
  "d-form-field__control-field": "_d-form-field__control-field_sb5u1_100",
  "d-form-field__control-left": "_d-form-field__control-left_sb5u1_106",
  "d-form-field__control-right": "_d-form-field__control-right_sb5u1_110",
  "d-form-field__prepend": "_d-form-field__prepend_sb5u1_114",
  "d-form-field__append": "_d-form-field__append_sb5u1_118",
  "d-form-field__label": "_d-form-field__label_sb5u1_122",
  "d-form-field__label_ontop": "_d-form-field__label_ontop_sb5u1_139",
  "d-form-field__label_transparent": "_d-form-field__label_transparent_sb5u1_143",
  "d-form-field__bg": "_d-form-field__bg_sb5u1_149",
  "d-form-field__outline": "_d-form-field__outline_sb5u1_158",
  "d-form-field__icon": "_d-form-field__icon_sb5u1_169",
  "d-form-field__icon-clearable": "_d-form-field__icon-clearable_sb5u1_172",
  "d-form-field__icon_spin": "_d-form-field__icon_spin_sb5u1_175",
  spin: m,
  "d-form-field__messages": "_d-form-field__messages_sb5u1_186",
  "d-form-field__under": "_d-form-field__under_sb5u1_194"
};
var u = function() {
  var e = this, l = e._self._c;
  return e._self._setupProxy, l("div", { class: {
    [e.$style["d-form-field"]]: !0,
    [e.$style["d-form-field_state-focused"]]: e.focused,
    [e.$style["d-form-field_state-disabled"]]: e.disabled,
    [e.$style["d-form-field_state-error"]]: e.error,
    [e.$style["d-form-field_color-dark"]]: e.dark,
    [e.$style["d-form-field_size-small"]]: e.size === e.ESize.SMALL,
    [e.$style["d-form-field_size-small_with-label"]]: !e.hideLabelOnFocus
  } }, [e.$slots.prepend ? l("div", { class: e.$style["d-form-field__prepend"] }, [e._t("prepend")], 2) : e._e(), e.$slots.append ? l("div", { class: e.$style["d-form-field__append"] }, [e._t("append")], 2) : e._e(), l("div", { class: e.$style["d-form-field__control"] }, [l("div", { class: e.$style["d-form-field__bg"] }), l("div", { class: e.$style["d-form-field__control-field"] }, [e._t("control", null, { id: e.id }), l("label", { class: {
    [e.$style["d-form-field__label"]]: !0,
    [e.$style["d-form-field__label_ontop"]]: e.focused || e.hasValue,
    [e.$style["d-form-field__label_transparent"]]: e.hideLabelOnFocus && (e.focused || e.hasValue)
  }, attrs: { dsiabled: e.disabled, readonly: e.blocked, for: e.id } }, [e._t("label", null, { for: e.id })], 2)], 2), e.$slots.innerPrepend ? l("div", { class: e.$style["d-form-field__control-left"] }, [e._t("innerPrepend")], 2) : e._e(), e.$slots.innerAppend || e.blocked || e.disabled || e.loading || e.clearable ? l("div", { class: e.$style["d-form-field__control-right"] }, [e.blocked || e.disabled ? l("DIcon", { class: {
    [e.$style["d-form-field__icon"]]: !0
  }, attrs: { name: e.EIcon.SAFETY_SAFETY, size: e.EIconSize.S_16, color: e.disabled || !e.dark && e.blocked ? e.EIconColor.GREY_284 : e.EIconColor.WHITE_101, bold: "" } }) : e.loading ? l("DIcon", { class: {
    [e.$style["d-form-field__icon"]]: !0,
    [e.$style["d-form-field__icon_spin"]]: !0
  }, attrs: { name: e.EIcon.LOADERS_DEFAULT, size: e.EIconSize.S_16, color: e.dark ? e.EIconColor.WHITE_101 : e.EIconColor.PRIMARY } }) : e.clearable ? l("DIcon", { class: {
    [e.$style["d-form-field__icon"]]: !0,
    [e.$style["d-form-field__icon-clearable"]]: !0
  }, attrs: { name: e.EIcon.CHECK_CLOSE, size: e.EIconSize.S_16, color: e.dark ? e.EIconColor.WHITE_101 : e.EIconColor.GREY_1514, bold: "" }, on: { click: e.onClear } }) : e._e(), e._t("innerAppend")], 2) : e._e(), l("div", { class: e.$style["d-form-field__outline"] })]), e.$slots.under ? l("div", { class: e.$style["d-form-field__under"] }, [e._t("under")], 2) : e._e(), e.$slots.messages && !e.disabled ? l("div", { class: e.$style["d-form-field__messages"] }, [e._t("messages")], 2) : e._e()]);
}, p = [];
const d = {
  $style: b
};
function $(o) {
  for (var e in d)
    this[e] = d[e];
}
var E = /* @__PURE__ */ t(
  c,
  u,
  p,
  !1,
  $
);
const C = E.exports;
export {
  C as D,
  _ as E
};
